import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFolderArrowRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.102 5.5H5a.5.5 0 0 0-.5.5v1h7.16l-1.184-1.332a.5.5 0 0 0-.374-.168M3 6v4.75a.75.75 0 0 0 1.5 0V8.5H18a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 17v-.03a.75.75 0 0 0-1.5 0V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-4.333l-2.07-2.329A2 2 0 0 0 10.102 4H5a2 2 0 0 0-2 2m4.284 10.655a.75.75 0 0 1 0-1.06l.85-.85H3.758a.75.75 0 1 1 0-1.5h4.358l-.832-.832a.75.75 0 1 1 1.06-1.061l2.122 2.121.53.53-.53.53-2.121 2.122a.75.75 0 0 1-1.061 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowRight24);
